import { Input, Typography } from "antd";
import React, { useMemo, useState } from "react";
import { AllUsersFilesColumns } from "./user-files-columns";
import { API_URL, fetcher } from "../../../utils/fetcher";
import useSWR from "swr";
import { AllBusinessRoot } from "../../../types/AllBusinessTypes";
import { useLocation } from "react-router-dom";
import { AllUserFilesRoot } from "../../../types/AllUserFileTypes";
import { AppTable } from "../../../components/common";

export default function AllUserFiles() {
  const { Text } = Typography;
  const [searchText, setSearchText] = useState("");
  const location = useLocation();
  const lastSegment = location?.pathname.split("/").pop();
  const decodedCompanyName = lastSegment
    ? decodeURIComponent(lastSegment)
    : "-";
  const companyId = location?.state?.companyId;

  const { data: userFilesData, isLoading: businessLoading } =
    useSWR<AllUserFilesRoot>(
      `${API_URL}/sessionHistory/getHistoryByCompanyId/${companyId}`,
      fetcher,
      {
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        revalidateOnMount: true,
      }
    );

  // const filteredData = useMemo(() => {
  //   if (!searchText) return businessData?.data ?? [];

  //   return (businessData?.data ?? []).filter((item) =>
  //     item?.name?.toLowerCase().includes(searchText.toLowerCase())
  //   );
  // }, [businessData?.data, searchText]);

  return (
    <div>
      <div className="allBusinesses">
        <div className="filterMenu">
          <Text className="title24">{`User Files & Sessions History > ${decodedCompanyName}`}</Text>
          <Input.Search
            className="searchField"
            placeholder="Search here..."
            onChange={(e) => setSearchText(e.target.value)}
            onSearch={(value) => {
              setSearchText(value);
            }}
          />
        </div>
        <AppTable
          rowKey={(record) => record.user._id}
          loading={businessLoading}
          columns={AllUsersFilesColumns(decodedCompanyName, searchText)}
          dataSource={userFilesData?.data ?? []}
        />
      </div>
    </div>
  );
}
